module.exports = {"id":"203627","name":"Joãozinho","rating":"78","photo":"./data/images/photos/4/203627.png","club":{"name":"FK Krasnodar","logo":"./data/images/clubs/FKKrasnodar.png"},"positions":["MG","AG","MD","AD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Joaozinho0.json
// module id = 2040
// module chunks = 0